import { Pipe, PipeTransform } from '@angular/core';
import { FlowNode } from '../interfaces/flow-ui.interface';
import { NodeData, NodeType } from '../interfaces/node.interface';
import { TriggerNodesEnum } from '../services/graph.utils';

@Pipe({
  name: 'nodeWarningTooltip',
  standalone: true,
})
export class NodeWarningTooltipPipe implements PipeTransform {
  excludeNodes = [NodeType.Wait, NodeType.Gateway, NodeType.Notify, NodeType.Start, NodeType.End, NodeType.Terminate];

  transform(data: FlowNode<NodeData<unknown[]>>): boolean {
    if (!data?.nodeData) {
      return false;
    }

    const { nodeData } = data;

    if (nodeData.type === NodeType.Trigger) {
      // Only the scheduler trigger requires parameters; webhook / api triggers are valid without them.
      return !nodeData.parameters?.length && nodeData.name === TriggerNodesEnum.Schedule;
    }

    return !nodeData.parameters?.length && !this.excludeNodes.includes(nodeData.type);
  }
}
